import { type ComponentProps } from "react"

import { LoaderCircleIcon } from "lucide-react"

import { Button } from "@/components/ui/button"

interface ButtonNextProps extends ComponentProps<typeof Button> {
  isLoading?: boolean
}

export function ButtonNext({
  type = "submit",
  children = "Next",
  isLoading = false,
  ...props
}: ButtonNextProps) {
  return (
    <Button
      type={type}
      className="bg-primary flex h-12 min-w-35 cursor-pointer items-center rounded-lg px-8 py-3 text-white transition-opacity disabled:pointer-events-none disabled:opacity-50"
      {...props}
    >
      <span>{children}</span>

      {isLoading ? (
        <div className="ml-2 grid h-5 w-5 place-content-center">
          <LoaderCircleIcon className="animate-spin" />
        </div>
      ) : null}
    </Button>
  )
}
